import { mockSolEvmChainId } from '../config/sol';
import { mockBtcEvmChainId } from '../config/btc';
import { mockTonChainId } from '../config/ton';
export const mockEvmChainIds = {
  SOL: mockSolEvmChainId,
  BTC: mockBtcEvmChainId,
  TON: mockTonChainId,
};
